<template>
	<div class="section">
		<div class="container">
			<h1>Saved Searches</h1>
			<b-table :data="searches"
					 hoverable
					 mobile-cards
					 paginated
					 :loading="isLoading"
					 :per-page="10"
					 pagination-simple>
				<template>
					<b-table-column field="Name" label="Name" sortable v-slot="props">
						{{ props.row.Name }}
					</b-table-column>
					<b-table-column field="CreatedOn" label="Created On" sortable v-slot="props">
						{{ props.row.CreatedOn | moment('MM/DD/YYYY') }}
					</b-table-column>
					<b-table-column field="IsSubscribed" v-slot="props">
						<p class="yellow"><i class="fas fa-users"></i>&nbsp;<span v-if="props.row.IsSubscribed"><a @click="unsubscribe(props.row.Id)">Unsubscribe</a></span><span v-if="!props.row.IsSubscribed"><a @click="subscribe(props.row.Id)">Subscribe</a></span></p>
					</b-table-column>
					<b-table-column v-slot="props">
						<p class="blue"><i class="fas fa-search"></i>&nbsp;<a @click="search(props.row)">Search</a></p>
					</b-table-column>
					<b-table-column v-slot="props">
						<p class="red"><i class="fas fa-trash"></i>&nbsp;<a @click="deleteQuery(props.row.Id)">Delete</a></p>
					</b-table-column>
				</template>
			</b-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				searches: [],
				isLoading: false
			}
		},
		async created() {
			this.isLoading = true;
			await this.getSearches();
		},
		methods: {
			async getSearches() {
				await this.$http.get("api/search")
					.then(resp => {
						this.searches = resp.data;
						this.isLoading = false;
					}).catch(err => {
						console.log(err);
					})
			},
			subscribe(id) {
				this.$http.post("api/search/subscribe/" + id)
					.then(resp => {
						this.$buefy.toast.open(resp.data);

						const newSearches = [];
						this.searches.forEach(s => {
							if (s.Id == id) {
								s.IsSubscribed = !s.IsSubscribed;
							}
							newSearches.push(s);
						})
						this.searches = newSearches;
					}).catch(err => {
						console.log(err);
					})
			},
			unsubscribe(id) {
				this.$http.post("api/search/unsubscribe/" + id)
					.then(resp => {
						this.$buefy.toast.open(resp.data);

						const newSearches = [];
						this.searches.forEach(s => {
							if (s.Id == id) {
								s.IsSubscribed = !s.IsSubscribed;
							}
							newSearches.push(s);
						})
						this.searches = newSearches;
					}).catch(err => {
						console.log(err);
					})
			},
			deleteQuery(id) {
				this.$http.delete("api/search/" + id)
					.then(resp => {
						this.$buefy.toast.open(resp.data);

						const newSearches = [];
						this.searches.forEach(s => {
							if (s.Id != id) {
								newSearches.push(s);
							}
						})
						this.searches = newSearches;
					}).catch(err => {
						console.log(err);
					})
			},
			async search(row) {
				this.$set(row, "searching", true);
				try {
					var response = await this.$http.get("/api/search/" + row.Id + "/query");
					if (response.data) {
						sessionStorage.removeItem("BSDBResults");
						this.$store.dispatch("setQuery", response.data);
						this.$store.dispatch("setQueryId", row.Id);
						this.$router.push("/results");
					}
				}
				catch (err) {
					this.$set(row, "searching", false);
					console.error(err);
					return Promise.reject();
				}
			}
		}
	}
</script>

<style>

	.yellow {
		color: #FDB727 !important
	}

		.yellow a {
			color: #FDB727 !important
		}

	.blue {
		color: #2F4E6F !important
	}

		.blue a {
			color: #2F4E6F !important
		}

	.red {
		color: red !important
	}

		.red a {
			color: red !important
		}
</style>
